// Ручной ввод координат косяка: клик по карте задаёт точку грубо, а промысловая
// отметка приходит из журнала цифрами. Разбор строгий — молчаливо принять мусор
// и поставить точку в Гвинейский залив хуже, чем не дать сохранить.

/** Число с необязательной дробной частью; запятая допустима как разделитель. */
const NUM_RE = /^[+-]?(\d+([.,]\d*)?|[.,]\d+)$/

/** Строка → координата. null, если это не конечное число. */
export function parseCoord(text: string): number | null {
  const s = text.trim()
  if (!NUM_RE.test(s)) return null
  const n = Number(s.replace(',', '.'))
  return Number.isFinite(n) ? n : null
}

export function validLat(n: number | null): boolean {
  return n !== null && n >= -90 && n <= 90
}

export function validLon(n: number | null): boolean {
  return n !== null && n >= -180 && n <= 180
}

/** 4 знака — точность ~11 м, достаточно для отметки косяка и не режет клик по карте. */
export function formatCoord(n: number): string {
  return n.toFixed(4)
}

/** Координаты точки для переноса в навигатор: «65.5, 167.76».
 *
 *  Широта первой (как в судовождении), хвостовые нули отброшены — их незачем
 *  перебивать вручную. Точность та же, что у отметки: 4 знака ≈ 11 м. */
export function formatLatLon(lat: number, lon: number): string {
  return `${trimZeros(lat)}, ${trimZeros(lon)}`
}

function trimZeros(n: number): string {
  return formatCoord(n).replace(/\.?0+$/, '')
}
